"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomeGapPageFive;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _IncomeGapBarCharts = require("./IncomeGapBarCharts");
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _utils = require("../../middleware/utils");
var _CollapseInfoThreeColumn = _interopRequireDefault(require("../Wizard/CollapseInfoThreeColumn"));
var _RetirementIncomeGapRefineModal = _interopRequireDefault(require("./RetirementIncomeGapRefineModal"));
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RetirementIncomeGapPageFive(_ref) {
  var {
    showDisclosure,
    disclosureHandleClose,
    setHasRetirementIncomeGap,
    showRefinement,
    snapshot,
    refinementHandleClose,
    setValidationData,
    setSnapshot,
    currentExpenses,
    setCurrentExpenses,
    futureExpenses,
    setFutureExpenses
  } = _ref;
  var {
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    document.getElementById(_RetirementIncomeGapWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else*/
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  var willNeedValue = sumFutureExpenses();
  var willHaveValue = sumRetirementIncome();
  var retireIncomeGapValue = willNeedValue - willHaveValue;
  var incomeGapText = "Your estimated retirement income gap is ".concat((0, _utils.numberToCurrencyString)(retireIncomeGapValue), " a month. Let's work together to figure out how to close this gap.");
  var noIncomeGapText = 'Based on your future expenses and anticipated retirement income, you do not have a gap.';
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    // We might be able to use setValues instead of looping through.
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };

  // setting state and text relevant to if you have a retirment gap or not
  var headerText;
  if (retireIncomeGapValue > 0) {
    setHasRetirementIncomeGap(true);
    headerText = incomeGapText;
  } else {
    setHasRetirementIncomeGap(false);
    headerText = noIncomeGapText;
  }

  // setting up both contentArrays for dropdown component, different component rendered for mobile/tablet vs desktop
  var contentArrayDesktop = [{
    label: 'Current Age',
    value1: '',
    value2: values.currentAge
  }, {
    label: 'Retirement Age',
    value1: '',
    value2: values.retirementAge
  }, {
    label: 'Social Security Income',
    value1: '',
    value2: "$".concat(values.socialSecurityBenefit, " /month")
  }, {
    label: 'Pension Income',
    value1: '',
    value2: "$".concat(values.pension, " /month")
  }, {
    label: 'Other Income',
    value1: '',
    value2: "$".concat(values.otherIncome, " /month"),
    hr: true
  }, {
    label: '<strong>Expense Category</strong>',
    value1: '<strong>Current Expense</strong>',
    value2: '<strong>Future Expense</strong>',
    hr: true
  }, {
    label: 'Housing & Insurance',
    value1: "$".concat(values.housingAndInsuranceCost, " /month"),
    value2: "$".concat(values.future_housingAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Healthcare & Insurance',
    value1: "$".concat(values.healthcareAndInsuranceCost, " /month"),
    value2: "$".concat(values.future_healthcareAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Transportation & Insurance',
    value1: "$".concat(values.transportationAndInsuranceCost, " /month"),
    value2: "$".concat(values.future_transportationAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Groceries & Dining Out',
    value1: "$".concat(values.groceriesAndDiningOutCost, " /month"),
    value2: "$".concat(values.future_groceriesAndDiningOutCost, " /month"),
    hr: true
  }, {
    label: 'Travel & Entertainment',
    value1: "$".concat(values.travelAndEntertainmentCost, " /month"),
    value2: "$".concat(values.future_travelAndEntertainmentCost, " /month"),
    hr: true
  }, {
    label: 'Personal & Miscellaneous',
    value1: "$".concat(values.personalAndMiscellaneousCost, " /month"),
    value2: "$".concat(values.future_personalAndMiscellaneousCost, " /month")
  }];
  var contentArrayTabletMobile = [{
    label: 'Current Age',
    value1: '',
    value2: values.currentAge
  }, {
    label: 'Retirement Age',
    value1: '',
    value2: values.retirementAge
  }, {
    label: 'Social Security Income',
    value1: '',
    value2: "$".concat(values.socialSecurityBenefit, " /month")
  }, {
    label: 'Pension Income',
    value1: '',
    value2: "$".concat(values.pension, " /month")
  }, {
    label: 'Other Income',
    value1: '',
    value2: "$".concat(values.otherIncome, " /month"),
    hr: true
  }, {
    label: '<strong>Expense Category</strong>',
    value1: '',
    value2: '<strong>Current Expense</strong>',
    hr: true
  }, {
    label: 'Housing & Insurance',
    value1: "",
    value2: "$".concat(values.housingAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Healthcare & Insurance',
    value1: "",
    value2: "$".concat(values.healthcareAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Transportation & Insurance',
    value1: "",
    value2: "$".concat(values.transportationAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Groceries & Dining Out',
    value1: "",
    value2: "$".concat(values.groceriesAndDiningOutCost, " /month"),
    hr: true
  }, {
    label: 'Travel & Entertainment',
    value1: "",
    value2: "$".concat(values.travelAndEntertainmentCost, " /month"),
    hr: true
  }, {
    label: 'Personal & Miscellaneous',
    value1: "",
    value2: "$".concat(values.personalAndMiscellaneousCost, " /month"),
    hr: true
  }, {
    label: '<strong>Expense Category</strong>',
    value1: '',
    value2: '<strong>Future Expense</strong>',
    hr: true
  }, {
    label: 'Housing & Insurance',
    value1: "",
    value2: "$".concat(values.future_housingAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Healthcare & Insurance',
    value1: "",
    value2: "$".concat(values.future_healthcareAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Transportation & Insurance',
    value1: "",
    value2: "$".concat(values.future_transportationAndInsuranceCost, " /month"),
    hr: true
  }, {
    label: 'Groceries & Dining Out',
    value1: "",
    value2: "$".concat(values.future_groceriesAndDiningOutCost, " /month"),
    hr: true
  }, {
    label: 'Travel & Entertainment',
    value1: "",
    value2: "$".concat(values.future_travelAndEntertainmentCost, " /month"),
    hr: true
  }, {
    label: 'Personal & Miscellaneous',
    value1: "",
    value2: "$".concat(values.future_personalAndMiscellaneousCost, " /month")
  }];
  function sumFutureExpenses() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_housingAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_healthcareAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_transportationAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_groceriesAndDiningOutCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_travelAndEntertainmentCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_personalAndMiscellaneousCost));
  }
  function sumRetirementIncome() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.socialSecurityBenefit)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.pension)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.otherIncome));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h5", null, " ", headerText, " "), /*#__PURE__*/_react.default.createElement(_IncomeGapBarCharts.DesktopBarGraph, {
    willHaveValue: willHaveValue,
    willNeedValue: willNeedValue,
    retireIncomeGapValue: retireIncomeGapValue
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_IncomeGapBarCharts.MobileBarGraph, {
    willHaveValue: willHaveValue,
    willNeedValue: willNeedValue,
    retireIncomeGapValue: retireIncomeGapValue
  }), /*#__PURE__*/_react.default.createElement(_CollapseInfoThreeColumn.default, {
    className: "mm-desktop-only",
    label: '<strong>General Information & Income</strong>',
    id: "rig_results",
    contentArray: contentArrayDesktop
  }), /*#__PURE__*/_react.default.createElement(_CollapseInfoThreeColumn.default, {
    className: "mm-tablet-mobile-only",
    label: '<strong>General Information & Income</strong>',
    id: "rig_results",
    contentArray: contentArrayTabletMobile
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapRefineModal.default, {
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    show: showRefinement,
    setValidationData: setValidationData,
    setSnapshot: setSnapshot,
    currentExpenses: currentExpenses,
    setCurrentExpenses: setCurrentExpenses,
    futureExpenses: futureExpenses,
    setFutureExpenses: setFutureExpenses
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    handleClose: disclosureHandleClose,
    show: showDisclosure,
    textArray: disclosureTextArray
  }));
}
var disclosureTextArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. All projections are hypothetical in nature, do not reflect actual results, and are not guarantees of future results. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];